var _circle, _path, _path2, _path3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.5,
    stroke: "#E4DFD4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7C16.4253 7.6206 14.3169 8 12 8C9.68312 8 7.57473 7.6206 6 7",
    stroke: "#E4DFD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17C16.4253 16.3794 14.3169 16 12 16C9.68312 16 7.57473 16.3794 6 17",
    stroke: "#E4DFD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12C15.5 14.1483 15.0635 16.0686 14.3812 17.4332C13.6839 18.8278 12.8132 19.5 12 19.5C11.1868 19.5 10.3161 18.8278 9.61879 17.4332C8.93646 16.0686 8.5 14.1483 8.5 12C8.5 9.85165 8.93646 7.93141 9.61879 6.56675C10.3161 5.17219 11.1868 4.5 12 4.5C12.8132 4.5 13.6839 5.17219 14.3812 6.56675C15.0635 7.93141 15.5 9.85165 15.5 12Z",
    stroke: "#E4DFD4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12,
    stroke: "#E4DFD4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 4,
    stroke: "#E4DFD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe-icon.34650537876c682bee3099cd4958709a.svg";
export { ForwardRef as ReactComponent };